import { Card } from "react-bootstrap";
import clsx from "clsx";
import BigStat from "./BigStat.jsx";
import styles from './StatCard.module.css';
import DataSource from "./DataSource.jsx";

function StatCard({title, time, disclaimer, dataSource, className, ...props}) {
  return (
    <>
      <Card className={clsx(styles.StatCard, className)}>
        <Card.Body className={styles.StatCardBody}>
          <h4 className={styles.StatCardTitle}>{title}</h4>
          <BigStat {...props} />
          {time && (
            <div className={styles.StatCardTime}>
              {new Date(time).toLocaleString('en-AU')}
            </div>
          )}
          <div className={styles.StatCardDisclaimer}>
              {disclaimer}
          </div>
          <DataSource dataSource={dataSource} />
        </Card.Body>
      </Card>
    </>
  )
}

export default StatCard
